module.exports = __webpack_public_path__ + "static/media/AHV-2.6c638775.png";